export enum TimeoutStatus {
  Scheduled,
  Completed
}


// WEBPACK FOOTER //
// ./src/timeout/timeout-status.model.ts